// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"index_content-wrapper_25hgV"};